<!-- Do not change this file. -->
<template>
  <div class="d-flex flex-column h-100">
    <div>
      <TheHeader />
      <TheNavbar />
    </div>
    <!-- TODO: check how much of this styling is still needed -->
    <div class="flex-grow-1 position-relative p-0" :class="{ 'overflow-hidden': inActivity }">
      <div class="h-100 d-flex flex-column flex-lg-row">
        <div class="flex-grow-1 d-flex flex-column">
          <router-view />
        </div>
      </div>
    </div>
    <TheFooter />
  </div>
</template>

<script>
/* Do not change this file. */

import TheHeader from "@/components/core/TheHeader";
import TheFooter from "@/components/core/TheFooter";
import TheNavbar from "@/components/core/TheNavbar";

// API for performing CRUD operations from the Datastore
import DatastoreAPI from "@/helpers/DatastoreAPI";

import { mapState, mapGetters, mapActions } from "vuex";

import config from "@/data/config";

export default {
  name: "App",
  mixins: [DatastoreAPI],
  data() {
    return {
      backgroundClass: config.appStyle.backgroundClass
    };
  },
  components: {
    TheHeader,
    TheNavbar,
    TheFooter
  },
  computed: {
    ...mapState("datastore", ["entry", "entryLoaded"]),
    ...mapGetters(["mapToDatastore", "useDatastore"]),
    inActivity() {
      return this.$route.path.startsWith("/activity");
    }
  },
  methods: {
    ...mapActions({
      mapFromDatastore: "mapFromDatastore",
      setEntry: "datastore/setEntry"
    })
  },
  watch: {
    /* Each time the route changes, read from the datastore */
    $route(to) {
      this.readEntry();
      // When datastore is disabled, initialize sections from default state
      if (!this.useDatastore && to.path.startsWith("/activity")) {
        this.mapFromDatastore("");
        // Set entryLoaded to true so SurveyingScene initializes stakes
        this.setEntry("");
      }
    },
    entry() {
      /* When Vuex datastore/entry updates,
      map to Vuex App State */
      this.mapFromDatastore(this.entry);
    },
    entryLoaded() {
      /* When Vuex datastore/entryLoaded updates,
      here is an opportunity to initial */
      if (this.entry === "") {
        // call vuex actions to set your initial state, then call....
        // this.setSomething(value);
        this.updateEntry(this.mapToDatastore);
      }
    }
  }
};
</script>
